import { masterV2Api } from "@/apis/interceptor"
import { IDepartmentResponse, IPaginationParamV2, IResponse } from "@/types"

export const departmentsService = {
  getDepartmentsService: async (params: IPaginationParamV2): Promise<IResponse<IDepartmentResponse>> => {
    const response = await masterV2Api.get<IResponse<IDepartmentResponse>>("/v1/departments", { params })
    return response.data
  },
}
